const React = require('react')
const PropTypes = require('prop-types')
const withStyles = require('withStyles').default
const SignupButtons = require('./signup_buttons')
const products = require('data/products')
const Currency = require('lib/currency')
const styles = require('./footer.less')

const { pro, pro_monthly, standard, standard_monthly } = products.index

function FreeColumn() {
    return (
        <div className="free product">
            <div className="title">
                <div className="name">Free</div>
                <div className="prices">
                    <div className="large-price">
                        $0/yr
                    </div>
                    <div className="small-price">
                        &nbsp;
                    </div>
                </div>
            </div>
            <ul className="feature">
                <li className="glyph-check">about.me page</li>
                <li className="glyph-check">Email signature</li>
            </ul>
        </div>
    )
}

function StandardColumn() {
    return (
        <div className="standard product">
            <div className="title">
                <div className="name">Standard</div>
                <div className="prices">
                    <div className="large-price">
                        {Currency.convertCentsToSimpleDollars(standard_monthly.price)}/mo
                    </div>
                    <div className="small-price">
                        or {Currency.convertCentsToSimpleDollars(standard.price)}/yr
                    </div>
                </div>
            </div>
            <ul className="feature">
                <li className="glyph-check">about.me page</li>
                <li className="glyph-check"><a href="/virtualtwin">AI Virtual Twin</a></li>
                <li className="glyph-check">Email signature</li>
            </ul>
        </div>
    )
}

function ProColumn() {
    return (
        <div className="starter product">
            <div className="title">
                <div className="name">{pro.title}</div>
                <div className="prices">
                    <div className="large-price">
                        {Currency.convertCentsToSimpleDollars(pro_monthly.price)}/mo
                    </div>
                    <div className="small-price">
                        or {Currency.convertCentsToSimpleDollars(pro.price)}/yr
                    </div>
                </div>
            </div>
            <ul className="feature">
                <li className="glyph-check">about.me page</li>
                <li className="glyph-check"><a href="/virtualtwin">Virtual Twin AI</a></li>
                <li className="glyph-check">Email signature</li>
                <li className="glyph-check"><a href="/virtualtwin">AI Virtual Twin</a></li>
                <li className="glyph-check">Connect a domain (yourname.com)</li>
                <li className="glyph-check">Customizable Spotlight button</li>
                <li className="glyph-check">Capture leads and book appointments with your Google account</li>
                <li className="glyph-check">Image gallery or video embed</li>
                <li className="glyph-check">Remove about.me branding</li>
                <li className="glyph-check">Customer support</li>
            </ul>
        </div>
    )
}

function Footer(props) {
    return (
        <div className={styles.scope}>
            <div className="footer-wrapper">
                <div className="footer-content">
                    <h1>Upgrade</h1>
                    <h2>Add AI to your page and personalize your link with your name.</h2>
                    <div className="price-chart">
                        <FreeColumn />
                        <StandardColumn />
                        <ProColumn />
                    </div>
                    <SignupButtons
                        button_rank="quaternary"
                        button_luminance="light"
                        enable_facebook={props.enable_facebook}
                        enable_google={props.enable_google}
                        variant={props.variant}
                        />
                </div>
            </div>
        </div>
    )
}

Footer.propTypes = {
    enable_facebook: PropTypes.bool,
    enable_google: PropTypes.bool,
    variant: PropTypes.string,
}

module.exports = withStyles(styles)(Footer)
